export class ThemeElement {
  private element: HTMLElement;

  constructor(element: HTMLElement) {
    this.element = element;
  }

  addClass(cssClass: string): void {
    if (this.element) {
      this.element.classList.add(cssClass);
    }
  }

  removeClass(cssClass: string): void {
    if (this.element) {
      this.element.classList.remove(cssClass);
    }
  }

  setDataAttribute(name: string, value: string): void {
    if (this.element) {
      this.element.dataset[name] = value;
    }
  }

  removeDataAttribute(name: string): void {
    if (this.element && this.element.dataset[name]) {
      delete this.element.dataset[name];
    }
  }
}
